import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import SortRoundedIcon from '@mui/icons-material/SortRounded';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import WebRoundedIcon from '@mui/icons-material/WebRounded';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import CircleNotificationsRoundedIcon from '@mui/icons-material/CircleNotificationsRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {
    Grid, MenuItem, Select,
    Stack,
    useTheme
} from "@mui/material";
import tgsLogo from "../assets/tgs_logo.png"
import {Link} from "react-router-dom";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import {useContext, useState} from "react";
import AuthContext from "../context/AuthContext";
import TgsDialog from "./Dialog";
import packageJson from '../../package.json'
import { useTranslation } from 'react-i18next';
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {availableLanguages, countries} from "../utils/countries";
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import SpeakerPhoneRoundedIcon from '@mui/icons-material/SpeakerPhoneRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';


const drawerWidth = 240;

function ResponsiveDrawer(props) {
    const {t} = useTranslation()
    const {w} = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [logoutDialogOpen, setLogoutDialogOpen] = useState(false)
    const menuItems = [
        {name: t('menu.orders'), url: '/', icon: <SpeakerPhoneRoundedIcon/>},
        {name: t('menu.invoices'), url: '/invoices', icon: <ReceiptRoundedIcon/>},
        {name: t('menu.tour_guides'), url: '/tour-guides', icon: <ContactPhoneIcon/>},
    ]
    const theme = useTheme()
    const {logoutUser} = useContext(AuthContext)

    const handleDrawerToggle = () => setMobileOpen(!mobileOpen)

    const drawer = (
        <div style={{background: theme.palette.primary[500], height: '100%'}}>

            <Toolbar style={{background: theme.palette.primary[600]}}>
                <img src={tgsLogo} alt="Tgs logo" width='150px'/>
            </Toolbar>
            <Divider/>
            <List sx={{padding: '32px 16px'}}>
                {menuItems.map((item, index) => (
                    <ListItem key={item.name} className="menu-item" disablePadding sx={{paddingBottom: '3px'}}
                              component={Link}
                              to={item.url}>
                        <ListItemButton className="menu-button" sx={{background: props.label === item.name && theme.palette.primary[600], "&:hover": {background: theme.palette.primary[400]}}}>
                            <ListItemIcon className="menu-button__icon">
                                {item.icon}
                            </ListItemIcon>
                            <Typography variant="button" className="menu-button__text">{item.name}</Typography>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Typography variant='caption' sx={{
                color: '#fff',
                position: 'absolute',
                bottom: 40,
                left: '50%',
                transform: 'translateX(-50%)',
                '&:hover': {background: 'transparent'}
            }}>v. {packageJson.version}</Typography>
            <Button variant='text' sx={{
                color: '#fff',
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                '&:hover': {background: 'transparent'}
            }} startIcon={<LogoutRoundedIcon/>} onClick={() => setLogoutDialogOpen(true)}>{t('menu.logout')}</Button>
        </div>
    );

    const container = w !== undefined ? () => w().document.body : undefined;

    const logoutActions = <>
        <Button variant='outlined' style={{padding: 15}} onClick={() => setLogoutDialogOpen(false)}>{t('general.cancel')}</Button>
        <Button variant='contained' style={{padding: 15}} onClick={() => {
            setLogoutDialogOpen(false)
            logoutUser()
        }} endIcon={<LogoutRoundedIcon/>}>{t('menu.logout')}</Button>
    </>

    return (
        <Box sx={{display: 'flex'}}>
            <CssBaseline/>
            <AppBar sx={{
                width: {md: `calc(100% - ${drawerWidth}px)`},
                ml: {md: `${drawerWidth}px`},
                background: {xs: theme.palette.primary[600], sm: theme.palette.primary[600], md: '#fff'}
            }} position="fixed">
                <Container maxWidth="xl">

                    <Toolbar disableGutters>
                        <Stack spacing={1} sx={{
                            display: {xs: 'none', sm: 'none', md: 'flex'},
                            // paddingBottom: '5px',
                            // paddingTop: '5px',
                            alignItems: 'center'
                        }}>
                            <Typography variant="headline2" noWrap component="h1" color={theme.palette.primary[700]}>
                                {props.label}
                            </Typography>
                            <Stack direction='row' spacing={2}>
                                {props.filterButtons?.map((button, i) => <Button key={`f_button_${i}`} {...button.props}>{button.name}</Button>)}
                            </Stack>
                        </Stack>
                        <Box sx={{flexGrow: 0, display: {xs: 'flex', sm: 'flex', md: 'none'}}}>
                            {/*<img src={whiteLogo} alt="Dinobooking logo" width='100px'/>*/}
                        </Box>
                        <Box sx={{display: {xs: 'flex', md: 'none'}, marginLeft: 'auto', zIndex: '11'}}>
                            <div style={{color: '#fff'}}>
                                <IconButton
                                    size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleDrawerToggle}
                                    color="inherit"
                                >
                                    {!mobileOpen ? <MenuIcon/> : <CloseIcon/>}
                                </IconButton>
                            </div>
                        </Box>

                        <Stack sx={{
                            flexGrow: 1,
                            display: {xs: 'none', sm: 'none', md: 'flex'},
                            justifyContent: 'flex-end'
                        }} direction='row' spacing={1}>
                            {props.buttons?.map((button, i) =>
                                <Button
                                    key={`menu_button_${i}`}
                                    {...button.props}>{button.name}</Button>)}
                        </Stack>
                    </Toolbar>
                </Container>
                <Stack spacing={1} padding={1} direction='row' sx={{display: {xs: 'flex', md: 'none'}, alignItems: 'center', justifyContent: 'space-between', background: '#fff'}}>
                    <Typography variant='headline2' color={theme.palette.primary[700]}>{props.label}</Typography>
                    <Stack spacing={1} direction='row' alignItems='center' justifyContent='center'>
                        {props.filterButtonsMobile?.map((button, i) => <IconButton key={`f_button_${i}`} sx={{background: theme.palette.secondary[800], color: '#fff'}} {...button.props}>{button.props.endIcon}</IconButton>)}
                    </Stack>
                </Stack>
            </AppBar>
            <Box
                component="nav"
                sx={{width: {md: drawerWidth}, flexShrink: {sm: 0}}}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: {sm: 'block', md: 'none'},
                        '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: {xs: 'none', sm: 'none', md: 'block'},
                        '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
            <Box
                component="main"
                sx={{flexGrow: 1, width: {sm: '100%', md: `calc(100% - ${drawerWidth}px)`}}}
            >
                {/*<Toolbar/>*/}

                {props?.filterButtonsMobile ? <Box sx={{height: 110, display: {xs: 'block', md: 'none'}}}/> : <Box sx={{height: 70, display: {xs: 'block', md: 'none'}}}/>}
                {props.children}

                <TgsDialog open={logoutDialogOpen}
                           handleClose={() => setLogoutDialogOpen(false)}
                           title={t('menu.logout')}
                           subtitle={t('menu.sure_logout')}
                           actions={logoutActions}>

                </TgsDialog>
            </Box>
        </Box>
    );
}

export default ResponsiveDrawer;